<template>
  <div class="home" v-loading="loading">
    <ul class="section-btn">
      <li class="on"></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-six">

        <swiper id="slideShow" v-bind:options="slideShowOption" ref="slideShowRef" style="width: 100%;height: 100%;">
          
          <swiper-slide class="slideShowTwo" style="width: 100%;height: 100%;">
              <div class="page">
                <h3>捷规工程咨询</h3>
                <p>jiegui engineering consulting</p>
              </div>
              <p class="slogan">捷规咨询&nbsp;&nbsp;&nbsp;&nbsp;筑梦未来</p>
              <div class="arrow"><img src="../assets/img/icon-scroll4.png" alt="Bouncing Image" class="bounce-image"></div>
          </swiper-slide>
          <swiper-slide class="slideShowOne" style="width: 100%;height: 100%;">
            <div class="banner_text">
              <div class="container">
                <transition name="zoom-in">
                  <img style='width: 100%;' class="zoom-0" vlue-data="false" alt="" src="../assets/img/home/logo/mini/1.png">
                </transition>
                </div>
              </div>
          </swiper-slide>  
           <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="section section-2">
          <!--关于我们-->
          <div class="iabout">
            <div class="w_1280">
              <div class="iabout_b">
                <div class="iab_tit">
                  <p>COMPANY PROFILE</p>
                  <h3>公司简介</h3>
                  <span></span>
                </div>
                <div class="iab_b">
                  <div class="iab_txt">
                    <p style="line-height: 150%; text-indent: 32px; -ms-text-autospace: ideograph-numeric;">
上海捷规建筑工程咨询有限公司原隶属于上规设计院，创建于2008年4月，因突出设计主业，于2017年11月监理资质分立上海捷规建筑工程咨询有限公司。
                    </p>
                    <p style="line-height: 150%; text-indent: 32px; -ms-text-autospace: ideograph-numeric;">
                      公司以工程咨询、项目管理、工程监理、智慧化为主要业务方向，相辅相成，紧扣现代企业发展需求，拓展项目与产品，产品目前覆盖：项目管理、工程监理、工程专项咨询、第三方检查与评估、存量资产盘整尽职调查、项目管理平台、BIM咨询、智慧城市、智慧安防等业务。
                    </p>
                    
                    <p><a href="goin">……</a></p>
                  </div>
                  <div class="iab_more">
                    <a href="goin">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <h3>经典案例</h3>
          <p>Suecessful Cass</p>
        </div>
        <ul class="case-item">
          <li
            v-for="(item,index) in caseList"
            :key="index"
            v-lazy:background-image="imgserver + item.img"
          >
            <router-link
              class="text-decoration"
              :to="{ name: 'casedetails', params: { id: item.id }}"
            >
              <div class="case-item-hover">
                <p class="hover-title">{{item.title}}</p>
                <div class="bottom"></div>
                <div class="more">
                  <span>MORE</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
            <div :style="'order: '+ (i%2==0 ? 1: 3)">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: news.id }}"
              >
                <div class="item-img" v-lazy:background-image="imgserver + news.img"></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">
              <h3>{{news.title}}</h3>
              <p>{{news.content}}</p>
              <span>{{news.create_time}}</span>
            </div>
          </div>
        </div>
         <Bottom></Bottom>
      </swiper-slide>
    </swiper>
   
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Bottom from "../components/Bottom"; 

import $ from "jquery";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide,
    Bottom
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: false, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height:858 , // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            let swiper = this.$refs.mySwiper.swiper;
            //console.log(swiper.activeIndex); //滑动打印当前索引
            let index = swiper.activeIndex;

            $('.section-btn li').removeClass();
            $('.section-btn li').eq(index).addClass('on');
          }
        }
      },
      slideShowOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "horizontal", //水平方向移动
        autoplay: {   // 自动轮播
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        //修改分页器样式
          bulletClass : 'swiper-pagination-bullet',
          //激活样式
          bulletActiveClass: 'my-bullet-active',
        effect: 'fade',
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
          }
        },
        pagination: {
          el: '.swiper-pagination'
        },

      }
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("/gw/Cases/get_cases_all"),
        this.$http.get("/gw/News/index?type=1&num=3"),
      ])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.data;
          this.newsList = responseNews.data;
          this.loading = false;
        })
      );
  }
};
</script>
 
<style lang="scss" scoped>

.swiper-wrapper {
    transition-timing-function: linear !important; /* 没错就是这个属性 */
}
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  font-family: fantasy !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #16955c;
    }
  }

  .slogan {
    text-align: center;
    font-size: 5vw;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 100%;
  justify-content: center;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  
  li {
    width: 25%;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}
.slideShowOne {
  background: url(../assets/img/home/logo/1.jpg) no-repeat center;
  background-size: cover;
}
.slideShowTwo {
  background: url(../assets/img/home/logo/2.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home/logo/4.jpg) no-repeat center;
  background-size: cover;
}
//最新资讯
.news-content {
  //width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      color: #222;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #b88beb;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}

.arrow{
      -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    font-family: arial,"microsoft yahei" !important;
    font-size: 1.4rem;
    font-weight: 400;
    color: #222;
    -webkit-text-size-adjust: none;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    opacity: 1;
    z-index: 99;
    -webkit-animation: arrow 3s cubic-bezier(0.5,0,0.1,1) infinite;
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -30px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}
.section-btn{-webkit-tap-highlight-color: transparent;
			-webkit-font-smoothing: antialiased;
			font-family: arial,"microsoft yahei" !important;
			font-size: 1.4rem;
			font-weight: 400;
			line-height: 1.5;
			color: #222;
			-webkit-text-size-adjust: none;
			box-sizing: border-box;
			list-style: none;
			margin: 0;
			padding: 0;
			width: 20px;
			position: fixed;
			right: 30px;
			top: 50%;
			z-index: 99;
  }
  .section-btn li {
    width: 15px;
    height: 4px;
    cursor: pointer;
    text-indent: -9999px;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    margin-bottom: 13px;
    background: #dd050f;
    text-align: center;
    color: #fff;
    onsor: pointer;
}
.section-btn li.on {
    background: #e2e2e2;
    width: 30px;
}

.my-bullet-active{ 
    background: #ffffff; 
    opacity: 1; 
} 
.swiper-pagination-bullet{ 
    width: 20px;
     height: 20px;
     background: #b3e9cf; 
}
//幻灯片内部中心
.banner_text{
  -webkit-text-size-adjust: 100%;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif,"微软雅黑";
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  list-style: none;
  pointer-events: auto;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  z-index: 9;
  transform: translateY(-50%);
}
.container{
    -webkit-text-size-adjust: 100%;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif,"微软雅黑";
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    list-style: none;
    pointer-events: auto;
    box-sizing: border-box;
    padding-right: 4%;
    padding-left: 4%;
    margin-right: auto;
    margin-left: auto;
    width: 90%;
    position: relative;
    z-index: 2; 
    margin: inherit;
}
.PC_img .Animation{
    -webkit-text-size-adjust: 100%;
    font-size: 14px;
    line-height: 1.42857143;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif,"微软雅黑";
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    list-style: none;
    pointer-events: auto;
    box-sizing: border-box;
    border: 0;
    vertical-align: middle;
    outline: none;
    color: #333;
    display: block;
    transition: all 1s;
    width: auto;
   
    margin: 0 auto;
    opacity: 1;
    transform: none;
    transition-delay: .5s;
}
/* 定义淡入动画 */
.zoom-in-enter-active {
  animation: zoom-in 3s ease-in-out;
}
 
@keyframes zoom-in {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.bounce-image {  
    animation: bounce 1s infinite; /* 调用bounce动画，持续时间1秒，无限次循环 */  
  }  
  
  @keyframes bounce {  
    0%, 20%, 50%, 80%, 100% {  
      transform: translateY(0); /* 初始位置 */  
    }  
    40% {  
      transform: translateY(-30px); /* 向下移动30px */  
    }  
    60% {  
      transform: translateY(-15px); /* 稍微向上回弹一些 */  
    }  
  }  
//公司介紹部分
.section-2 {
    background-color: #a0131a;
    height: 100%;
    font-family: 微软雅黑, Microsoft YaHei;
    font-size: 16px;
    text-align: justify;
}
.iabout {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.w_1280 {
    max-width: 1280px;
    width: 100%;
    /* margin: 0 auto; */
}
.iabout_b {
    width: 80%;
    margin: 0 auto;
}
.iab_tit {
    width: 100%;
    margin-bottom: 30px;
}
.iab_tit p {
    font-size: 14px;
    text-align: center;
    color: #eee;
    margin-bottom: 10px;
    letter-spacing: 5px;
}
.iab_tit h3 {
    font-size: 36px;
    color: #fff;
    font-weight: normal;
    line-height: 50px;
    text-align: center;
}
.iab_tit span {
    display: block;
    width: 50px;
    height: 2px;
    background: #fff;
    margin: 15px auto 0 auto;
}
.iab_b .iab_txt {
    width: 100%;
    margin-bottom: 30px;
}
.iab_b .iab_txt p {
    font-size: 17px;
    line-height: 32px;
    color: #fff;
    margin-bottom: 10px;
    text-align: justify;
    text-indent: 2em;
}
.iab_b .iab_txt p a {
    display: block;
    color: #fff;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
}
.iab_more {
    width: 100%;
    margin-top: 30px;
}
.iab_more a {
    display: block;
    width: 150px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    background: #fff;
    color: #A0131A;
    border: 1px solid #fff;
    font-size: 16px;
    font-family: "microsoft yahei";
    margin: 0 auto;
}
</style>